module.exports = __webpack_public_path__ + "static/img/carousel-banner-all-ms.c8e5879.jpg";